import { PrimeIcons } from "primereact/api";
import { Button } from "primereact/button";

export const IconSortTable = ({
  sortingName,
  nomeCampo,
  onSortCallback,
  iconStatus,
}: any) => {
  return (
    <div
      className={`${
        iconStatus === null ? "sort-not-active" : "sort-active"
      } flex-container center align-center custom-column-header `}
    >
      {nomeCampo}
      <Button
        text
        icon={
          iconStatus === null
            ? PrimeIcons.SORT_ALT
            : iconStatus === 1
            ? PrimeIcons.SORT_AMOUNT_DOWN_ALT
            : PrimeIcons.SORT_AMOUNT_UP_ALT
        }
        className="sort-button"
        onClick={() => onSortCallback({ sortingName, iconStatus })}
      ></Button>
    </div>
  );
};
